import schemaDefaults from 'json-schema-defaults';
import hash from 'object-hash';
import React from 'react';
import { useDispatch } from 'react-redux';

import StarsSection from '@swf/components/StarsSection/StarsSection';
import type { PageState } from '@swf/core/models/page';
import type { StaticContext } from '@swf/core/types/StaticContext';
import schemata from '@swf/widgets/schema';

const { services, config } = schemaDefaults(schemata.FooterWidget);
const widget = { type: 'FooterWidget' as const, meta: { name: 'Footer Widget' }, services, config };
const id = `footerWidget/${hash(widget).slice(0, 8)}`;
export const widgetProps = { ...widget, id };
const page: PageState = {
  layout: { type: 'StarsLayout', sections: { main: { widgets: [widgetProps] } } }
};

const EmbeddedFooter: React.FC<{ staticContext?: StaticContext }> = ({ staticContext = {} }) => {
  const dispatch = useDispatch();
  staticContext.prefetch = async ({ dispatch }) => {
    dispatch.page.response(page);
    await dispatch.page.preload();
  };
  return dispatch[id] ? <StarsSection widgets={[widgetProps]} /> : null;
};

export default EmbeddedFooter;
